import axios from "_u/axios"

// 集中抄表列表
export const readingList = body => {
    return axios.post("api/bill/info/readingList", body)
}

// 抄表生成账单
export const readingMeter = body => {
    return axios.post("api/bill/info/readingMeter", { list: body })
}

// 抄表记录  assets/housemeter/list
export const housemeterList = body => {
    return axios.post("api/assets/housemeter/list", body)
}
